'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Activate = exports.ActivateUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _DisclosureArrow = require('components/DisclosureArrow/DisclosureArrow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivateUnwrapped = exports.ActivateUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ActivateUnwrapped, _PureComponent);

  function ActivateUnwrapped() {
    var _ref;

    var _temp, _this, _this3, _ret;

    (0, _classCallCheck3.default)(this, ActivateUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = ActivateUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ActivateUnwrapped)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {}, _this3.renderSection = function (section, sectionIndex) {
      var sectionId = sectionIndex + ' - ' + section.text;
      var selected = !!(typeof _this.state[sectionId] === 'undefined' ? section.preselected : _this.state[sectionId]);
      var handleClick = function handleClick() {
        return _this.setSelectedState(sectionId, !selected);
      };

      return _react2.default.createElement(
        'li',
        { className: 'live-activate__section', key: '' + section.text },
        _react2.default.createElement(
          'h3',
          { className: 'live-activate__section__text', onClick: handleClick },
          _react2.default.createElement(_DisclosureArrow.DisclosureArrow, { className: 'live-activate__arrow', open: selected }),
          _react2.default.createElement(
            'span',
            null,
            section.text
          )
        ),
        selected && section.steps && _react2.default.createElement(
          _react.Fragment,
          null,
          section.subtextStart && _react2.default.createElement(
            'p',
            { className: 'live-activate__section__subtext-start' },
            section.subtextStart
          ),
          _react2.default.createElement(
            'ul',
            { className: 'live-activate__sections__steps' },
            section.steps.map(function (step, stepIndex) {
              return _react2.default.createElement(
                'li',
                { key: step.text },
                _react2.default.createElement(
                  'h4',
                  null,
                  'Step ',
                  stepIndex + 1,
                  ': ',
                  step.text
                ),
                step.substeps && _react2.default.createElement(
                  'ul',
                  { className: 'live-activate__sections__steps__substeps' },
                  step.substeps.map(function (substep) {
                    return _react2.default.createElement(
                      'li',
                      { key: substep.text },
                      _react2.default.createElement(
                        'span',
                        null,
                        substep.text
                      ),
                      substep && _react2.default.createElement(
                        'span',
                        { className: 'live-activate__sections__steps__substeps__links' },
                        substep.links.map(function (link, linkIndex) {
                          return _react2.default.createElement(
                            'span',
                            { key: link.text },
                            _react2.default.createElement(
                              'a',
                              { href: link.url, target: '_blank', rel: 'noopener noreferrer' },
                              link.text
                            ),
                            linkIndex < substep.links.length - 1 && _react2.default.createElement('span', { className: 'live-activate__link--divider' })
                          );
                        })
                      )
                    );
                  })
                )
              );
            })
          ),
          section.subtextEnd && _react2.default.createElement(
            'p',
            { className: 'live-activate__section__subtext-end' },
            section.subtextEnd
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(ActivateUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('CP Live Activate Module', 'viewed', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'setSelectedState',
    value: function setSelectedState(sectionId, selected) {
      this.setState((0, _defineProperty3.default)({}, sectionId, selected));
      if (selected) {
        (0, _multitrack.ga)('CP Live Activate Module', 'expanded section', sectionId, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          sections = _props.sections.data,
          title = _props.title;


      return _react2.default.createElement(
        'div',
        { className: 'live-activate' },
        _react2.default.createElement(
          'h2',
          null,
          title
        ),
        sections && _react2.default.createElement(
          'ul',
          { className: 'live-activate__sections' },
          sections.map(function (section, i) {
            return _this2.renderSection(section, i);
          })
        )
      );
    }
  }]);
  return ActivateUnwrapped;
}(_react.PureComponent);

ActivateUnwrapped.propTypes = {
  sections: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      preselected: _propTypes2.default.bool,
      text: _propTypes2.default.string,
      steps: _propTypes2.default.shape({
        text: _propTypes2.default.string,
        substeps: _propTypes2.default.shape({
          text: _propTypes2.default.string,
          links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            url: _propTypes2.default.string,
            text: _propTypes2.default.string
          }))
        })
      }),
      subtextStart: _propTypes2.default.string,
      subtextEnd: _propTypes2.default.string
    }))
  }),
  title: _propTypes2.default.string.isRequired
};

var Activate = exports.Activate = (0, _TrackDwell2.default)(ActivateUnwrapped);